export const navItems = [
  { id: 'intro', label: '吃瓜入门', icon: 'ri-book-open-line' },
  { id: 'steps', label: '四步攻略', icon: 'ri-route-line' },
  { id: 'tips', label: '进阶技巧', icon: 'ri-lightbulb-flash-line' },
  { id: 'topics', label: '热门分类', icon: 'ri-layout-grid-line' },
  { id: 'picks', label: '热门话题', icon: 'ri-fire-line' },
  { id: 'faq', label: '常见问题', icon: 'ri-question-line' },
  { id: 'about', label: '关于我们', icon: 'ri-team-line' },
];

export const heroStats = [
  { value: '6', unit: '大', label: '热门分区', icon: 'ri-layout-grid-line' },
  { value: '4', unit: '步', label: '吃瓜流程', icon: 'ri-route-line' },
  { value: '20', unit: '+', label: '实用技巧', icon: 'ri-lightbulb-flash-line' },
  { value: '每日', unit: '', label: '热点更新', icon: 'ri-refresh-line' },
];

export const introPoints = [
  {
    icon: 'ri-water-flash-line',
    title: '什么是「吃瓜」',
    desc: '在中文互联网语境里，「吃瓜」指的是围观娱乐八卦、网红动态与网络热点事件。它不是简单刷新闻，而是有节奏地跟进一件事的起因、经过与后续。',
  },
  {
    icon: 'ri-global-line',
    title: '17.cc 是什么',
    desc: '17.cc 是一个汇集娱乐八卦、影视综艺、网红达人与网络热搜的资讯聚合入口，把分散在各处的热点集中呈现，方便读者一站了解当下最受关注的事。',
  },
  {
    icon: 'ri-footprint-line',
    title: '为什么要攻略',
    desc: '热点信息量大且更新快，没有方法很容易「瓜没吃明白」。掌握一套浏览路线，就能用更少时间抓住重点，也能避免被片面信息带偏。',
  },
];

export const steps = [
  {
    num: '01',
    icon: 'ri-compass-3-line',
    title: '选对入口',
    desc: '打开 17.cc 后，先从首页热搜榜或分区频道进入。按你关心的方向（娱乐、影视、网红等）点进对应栏目，比盲目翻信息流更高效。',
    tag: '定位',
  },
  {
    num: '02',
    icon: 'ri-eye-line',
    title: '快速扫读',
    desc: '先只读标题与摘要，用 30 秒判断这件事的热度、涉及的关键人物和大致方向。确认值得跟进后，再决定要不要深入。',
    tag: '筛选',
  },
  {
    num: '03',
    icon: 'ri-timeline-view',
    title: '深挖时间线',
    desc: '进入专题或话题聚合页，按时间顺序把相关条目串起来看。先看最早的起因，再看中间的发酵过程，前因后果一目了然。',
    tag: '梳理',
  },
  {
    num: '04',
    icon: 'ri-notification-3-line',
    title: '追更跟进',
    desc: '把感兴趣的话题收藏，关注对应的标签或频道。后续有新进展时第一时间回来补课，不会出现「隔天就落伍」的情况。',
    tag: '跟进',
  },
];

export const tips = [
  {
    icon: 'ri-search-eye-line',
    title: '关键词追踪',
    desc: '记住事件里的人名、作品名或事件代号，用站内搜索反复追踪同一关键词，能一次看到所有相关条目。',
    tag: '效率',
  },
  {
    icon: 'ri-scales-3-line',
    title: '多信源交叉验证',
    desc: '同一件事多看两三个来源，互相印证。遇到只有单一出处的说法先存疑，等更多信息出现再判断。',
    tag: '辨别',
  },
  {
    icon: 'ri-history-line',
    title: '善用时间线',
    desc: '优先看带时间标注的聚合页，而不是零散的短消息。时间线能帮你分清「哪句是旧闻、哪句是新进展」。',
    tag: '方法',
  },
  {
    icon: 'ri-bookmark-3-line',
    title: '建立瓜田清单',
    desc: '把长期关注的议题整理成自己的清单，分类收藏。想跟进时按清单逐条查看，不再靠记忆。',
    tag: '管理',
  },
  {
    icon: 'ri-emotion-happy-line',
    title: '保持理性克制',
    desc: '吃瓜是休闲，不站队、不传未证实的消息。理性围观既能看懂来龙去脉，也能避开无谓的争执。',
    tag: '心态',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '利用碎片时间',
    desc: '早晚各花十分钟扫一遍热榜更新，午休看一条深度聚合，碎片时间也能把当天重点吃透。',
    tag: '节奏',
  },
];

export const topicCategories = [
  {
    key: 'ent',
    name: '娱乐八卦',
    icon: 'ri-movie-2-line',
    desc: '明星动态、剧组消息与行业风向，是吃瓜最集中的区域。看这里先抓人物关系图，再顺着时间线看事情怎么发展。',
    items: [
      { title: '出道十年首次合作，新剧阵容官宣', heat: '热', time: '今天 09:20' },
      { title: '经纪公司回应解约传闻，措辞耐人寻味', heat: '热', time: '今天 08:05' },
      { title: '老牌组合重聚演唱会，粉丝集体回忆杀', heat: '温', time: '昨天 21:40' },
      { title: '年度颁奖季提名名单出炉，争议不断', heat: '温', time: '昨天 18:12' },
    ],
  },
  {
    key: 'show',
    name: '影视综艺',
    icon: 'ri-clapperboard-line',
    desc: '剧集、电影与综艺的口碑走向，适合边看边跟。重点关注开分前后与更新节点的讨论变化。',
    items: [
      { title: '悬疑剧收官夜话题登顶，结局引发两极讨论', heat: '热', time: '今天 10:02' },
      { title: '综艺新一季阵容曝光，路透照流出', heat: '温', time: '今天 07:30' },
      { title: '暑期档票房盘点，黑马影片意外逆袭', heat: '温', time: '昨天 20:15' },
      { title: '导演回应删减争议，长文解释创作取舍', heat: '新', time: '昨天 16:48' },
    ],
  },
  {
    key: 'creator',
    name: '网红达人',
    icon: 'ri-vidicon-line',
    desc: '内容创作者与直播圈的动态更新极快。建议关注本人账号与相关讨论区，两边对照着看。',
    items: [
      { title: '头部主播宣布调整直播时间，粉丝反应不一', heat: '热', time: '今天 11:10' },
      { title: '短视频博主联动企划上线，评论区玩梗不断', heat: '温', time: '今天 09:45' },
      { title: '美食区达人探店视频引热议，店家回应', heat: '温', time: '昨天 19:22' },
      { title: '创作者大会公布年度榜单，新人集体冒头', heat: '新', time: '昨天 14:30' },
    ],
  },
  {
    key: 'trend',
    name: '网络热搜',
    icon: 'ri-fire-line',
    desc: '热搜是吃瓜的总入口。看榜单时留意「上升快」的条目，它们往往还处在信息增量最大的阶段。',
    items: [
      { title: '一条日常动态意外登上榜首，网友接力解读', heat: '热', time: '此刻' },
      { title: '平台热梗一夜出圈，出处被逐条考据', heat: '热', time: '今天 12:05' },
      { title: '热门话题衍生二创爆发，模板同款刷屏', heat: '温', time: '今天 08:50' },
      { title: '季节性话题回潮，旧内容被重新翻出', heat: '新', time: '昨天 22:18' },
    ],
  },
  {
    key: 'sports',
    name: '体育竞技',
    icon: 'ri-basketball-line',
    desc: '赛事结果与转会动态是关注重点。看这里建议配合赛程表，先看结果再看讨论，避免被剧透。',
    items: [
      { title: '焦点战加时绝杀，赛后采访金句频出', heat: '热', time: '今天 11:55' },
      { title: '转会窗口关闭前最后一笔交易敲定', heat: '温', time: '今天 07:12' },
      { title: '老将宣布退役，生涯集锦刷屏', heat: '温', time: '昨天 20:40' },
      { title: '青训名单公布，多名新秀入选引期待', heat: '新', time: '昨天 15:20' },
    ],
  },
  {
    key: 'tech',
    name: '科技数码',
    icon: 'ri-cpu-line',
    desc: '新品发布与行业动向，节奏相对清晰。看这里重点抓参数对比与真实上手反馈。',
    items: [
      { title: '秋季新品发布会定档，预告片藏彩蛋', heat: '热', time: '今天 10:30' },
      { title: '新系统公测开启，首批体验反馈汇总', heat: '温', time: '今天 08:18' },
      { title: '国产芯片新进展公布，行业讨论升温', heat: '温', time: '昨天 17:55' },
      { title: '智能穿戴出货数据出炉，格局生变', heat: '新', time: '昨天 13:05' },
    ],
  },
];

export const hotPicks = [
  {
    seq: '17cc-pick-01',
    category: '娱乐八卦',
    title: '一条深夜动态引发连锁猜测，时间线该怎么看',
    excerpt: '从最早的模糊发言，到各方陆续回应，这件事在 24 小时内经历了三次反转。本文按时间顺序帮你把线索排好，看清每一步的动机与来源。',
    readTime: '6 分钟',
    date: '09-12',
    image: 'https://readdy.ai/api/search-image?query=Flat%20illustration%20of%20a%20timeline%20with%20speech%20bubbles%20and%20clock%20markers%20on%20a%20cream%20paper%20background%2C%20coral%20red%20and%20leaf%20green%20accents%2C%20minimalist%20editorial%20style&width=800&height=500&seq=17cc-pick-01&orientation=landscape',
  },
  {
    seq: '17cc-pick-02',
    category: '影视综艺',
    title: '收官夜口碑两极，这部剧到底值不值得追',
    excerpt: '开分之后评分一路震荡，讨论集中在结局处理与人物弧光上。我们把正反两方最有代表性的观点整理成了对照清单。',
    readTime: '8 分钟',
    date: '09-11',
    image: 'https://readdy.ai/api/search-image?query=Flat%20illustration%20of%20a%20film%20clapperboard%20and%20popcorn%20on%20a%20cream%20paper%20background%2C%20coral%20red%20and%20amber%20accents%2C%20minimalist%20editorial%20style&width=800&height=500&seq=17cc-pick-02&orientation=landscape',
  },
  {
    seq: '17cc-pick-03',
    category: '网红达人',
    title: '主播调整直播时间背后，粉丝生态发生了什么',
    excerpt: '一次时间调整牵出整个圈层的排班逻辑。看似小事，其实关系到内容方向与商业化节奏，值得展开聊聊。',
    readTime: '5 分钟',
    date: '09-11',
    image: 'https://readdy.ai/api/search-image?query=Flat%20illustration%20of%20a%20live%20streaming%20screen%20with%20chat%20bubbles%20on%20a%20cream%20paper%20background%2C%20coral%20red%20and%20leaf%20green%20accents%2C%20minimalist%20editorial%20style&width=800&height=500&seq=17cc-pick-03&orientation=landscape',
  },
  {
    seq: '17cc-pick-04',
    category: '网络热搜',
    title: '热梗一夜出圈，出处考据与传播路径复盘',
    excerpt: '一个梗从冷门到刷屏只用了一个下午。我们把它最早的出处、关键的二次创作节点和爆发时刻都标了出来。',
    readTime: '7 分钟',
    date: '09-10',
    image: 'https://readdy.ai/api/search-image?query=Flat%20illustration%20of%20rising%20trending%20arrows%20and%20hashtag%20symbols%20on%20a%20cream%20paper%20background%2C%20coral%20red%20and%20amber%20accents%2C%20minimalist%20editorial%20style&width=800&height=500&seq=17cc-pick-04&orientation=landscape',
  },
  {
    seq: '17cc-pick-05',
    category: '体育竞技',
    title: '加时绝杀之后，赛后采访里藏了哪些信息',
    excerpt: '比分只是结果，采访里的情绪与措辞往往透露出更多。我们逐句拆解了赛后发布会最值得注意的几段话。',
    readTime: '6 分钟',
    date: '09-10',
    image: 'https://readdy.ai/api/search-image?query=Flat%20illustration%20of%20a%20stadium%20with%20scoreboard%20and%20ball%20on%20a%20cream%20paper%20background%2C%20coral%20red%20and%20leaf%20green%20accents%2C%20minimalist%20editorial%20style&width=800&height=500&seq=17cc-pick-05&orientation=landscape',
  },
  {
    seq: '17cc-pick-06',
    category: '科技数码',
    title: '发布会前的预告彩蛋，参数爆料可信度排序',
    excerpt: '爆料满天飞的时候，先分清哪些来自官方、哪些来自渠道、哪些只是猜测。我们做了一份清晰的可信度分级表。',
    readTime: '9 分钟',
    date: '09-09',
    image: 'https://readdy.ai/api/search-image?query=Flat%20illustration%20of%20a%20smartphone%20and%20gadgets%20with%20spec%20cards%20on%20a%20cream%20paper%20background%2C%20coral%20red%20and%20amber%20accents%2C%20minimalist%20editorial%20style&width=800&height=500&seq=17cc-pick-06&orientation=landscape',
  },
];

export const faqs = [
  {
    q: '17.cc 到底要怎么吃瓜？新手应该从哪一步开始？',
    a: '先从首页热搜榜或分区频道进入，挑一个你感兴趣的话题点开。建议按四步攻略走：选对入口、快速扫读、深挖时间线、追更跟进。第一次不用贪多，把一个话题完整看完，就能掌握节奏。',
  },
  {
    q: '热点太多看不过来，有没有省时间的办法？',
    a: '用「先粗后细」的策略：先只读标题和摘要，30 秒判断值不值得跟进，真正有意思的再进入专题页细看。同时建立自己的关注清单，按分类收藏，避免每次从零开始翻找。',
  },
  {
    q: '怎么判断一条吃瓜信息是真是假？',
    a: '看三点：来源是否明确、是否只有单一出处、是否带有明显的情绪煽动。同一件事尽量看两到三个来源交叉验证，遇到只有一方说法且措辞夸张的内容，先存疑、等后续。',
  },
  {
    q: '17.cc 上的内容会持续更新吗？怎么跟进后续进展？',
    a: '热门话题通常会持续更新。你可以收藏话题、关注对应标签或频道，隔一段时间回来查看最新条目。遇到有争议的事件，建议按时间线看，而不只看最新的一条。',
  },
  {
    q: '吃瓜时应该注意什么？',
    a: '理性围观最重要：不传播未经证实的消息，不参与攻击性讨论，尊重当事人隐私。把吃瓜当成一种休闲方式，看懂来龙去脉就好，不必站队，也不必投入过多情绪。',
  },
  {
    q: '想系统学习吃瓜技巧，有没有推荐的学习路线？',
    a: '推荐按「入门 → 方法 → 心态」三步走：先用四步攻略跑通一次完整流程；再学习关键词追踪、多信源验证等进阶技巧；最后养成理性、克制的围观习惯。本页的进阶技巧板块可以作为长期参考。',
  },
];

export const testimonials = [
  {
    name: '林小满',
    role: '追热点党',
    content: '以前刷热搜经常一头雾水，看了这份攻略才知道要先看时间线。现在一件事的来龙去脉十分钟就能理顺，效率高太多了。',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20portrait%20of%20a%20young%20woman%20with%20short%20hair%20on%20a%20cream%20background%2C%20coral%20red%20accent%2C%20minimalist%20editorial%20style&width=200&height=200&seq=17cc-avatar-01&orientation=squarish',
  },
  {
    name: '周叙',
    role: '内容爱好者',
    content: '「多信源交叉验证」这条真的救了我。以前看到一条消息就转发，现在会先查两三个来源，少踩了好多坑。',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20portrait%20of%20a%20young%20man%20with%20glasses%20on%20a%20cream%20background%2C%20leaf%20green%20accent%2C%20minimalist%20editorial%20style&width=200&height=200&seq=17cc-avatar-02&orientation=squarish',
  },
  {
    name: '苏白',
    role: '影视区常客',
    content: '分类板块做得很清楚，影视综艺单独的路线特别实用。开分前后该看什么、更新节点怎么跟，都写得明明白白。',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20portrait%20of%20a%20woman%20with%20long%20hair%20on%20a%20cream%20background%2C%20amber%20accent%2C%20minimalist%20editorial%20style&width=200&height=200&seq=17cc-avatar-03&orientation=squarish',
  },
  {
    name: '陈嘉树',
    role: '效率工具控',
    content: '「瓜田清单」这个方法我直接照搬了，把所有关注的话题分类收藏，每天早晚各扫一遍，再也没漏过重点。',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20flat%20illustration%20portrait%20of%20a%20man%20with%20a%20cap%20on%20a%20cream%20background%2C%20coral%20red%20accent%2C%20minimalist%20editorial%20style&width=200&height=200&seq=17cc-avatar-04&orientation=squarish',
  },
];

export const siteInfo = {
  name: '17.cc吃瓜攻略指南',
  slogan: '把吃瓜这件事，讲成一门可以学会的手艺',
  email: 'contact@17cc-guide.com',
  intro: '我们是一群长期关注网络热点的普通读者，把零散的浏览经验整理成系统的攻略与教程，希望每个刚接触 17.cc 的人都能少走弯路。',
};